import { useQuery } from "@tanstack/react-query";

import { fetchMapSectorsInfo } from "../../services/network/map_sector-api";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS, KNOWLEDGE_BASE_ENDPOINTS} from "../../services/network/endpoints";
import {KnowledgeBaseAPI} from "../../services/network/knowledgeBase-api";

/**
 * Хук для получения списка корневых папок
 * @param enabled Флаг, указывающий, следует ли выполнять запрос
 */
export function useFetchKBFolders(enabled: boolean = true) {
  const { data, error, isLoading } = useQuery({
    queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDERS],
    queryFn: () => KnowledgeBaseAPI.fetchFolders(),
    select: (response) => response.data?.map(role => role) || [],
    enabled: enabled // Запрос будет выполнен только если enabled === true
  });

  return {
    KBFoldersData: data,
    KBFoldersError: error,
    KBFoldersIsLoading: isLoading,
  };
}
